let $productLink = $('.js-hover-anim');

function isHover(e) {
	let $animation = $(e.currentTarget).find('[class*="__animation"]');

	$animation.addClass('is-hover');
}

function isHoverOf(e) {
	let $animation = $(e.currentTarget).find('[class*="__animation"]');

	$animation.removeClass('is-hover');
}

if (innerWidth > 1024) {
	$productLink.on('mouseenter', isHover);
	$productLink.on('mouseleave', isHoverOf);
}
